<div class="help">
  <mat-icon
    [mdePopoverTriggerFor]="appPopover"
    (click)="$event.stopPropagation()"
    mdePopoverTriggerOn="click"
    #popoverTrigger="mdePopoverTrigger"
    class="help-icon"
  >
    info
  </mat-icon>
  <mde-popover #appPopover="mdePopover" [mdePopoverOverlapTrigger]="false">
    <mat-card class="help-container" style="max-width: 300px">
      <mat-card-content>
        <div class="help-container-title" *ngIf="title != ''">
          <h3 class="help-title">{{ title }}</h3>
          <mat-icon class="help-icon-close help-icon">close</mat-icon>
        </div>
        <div class="help-container-text">
          <ng-content></ng-content>
          <p [innerHtml]="msg"></p>
          <p>{{ msg2 }}</p>
          <p>{{ msg3 }}</p>
          <p>{{ msg4 }}</p>
        </div>
      </mat-card-content>
    </mat-card>
  </mde-popover>
</div>
